/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteUserVerificationRequest
 */
export interface DeleteUserVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteUserVerificationRequest
     */
    removeFromUserId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DeleteUserVerificationRequest
     */
    accessToken?: string | null;
}

/**
 * Check if a given object implements the DeleteUserVerificationRequest interface.
 */
export function instanceOfDeleteUserVerificationRequest(value: object): value is DeleteUserVerificationRequest {
    return true;
}

export function DeleteUserVerificationRequestFromJSON(json: any): DeleteUserVerificationRequest {
    return DeleteUserVerificationRequestFromJSONTyped(json, false);
}

export function DeleteUserVerificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteUserVerificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'removeFromUserId': json['removeFromUserId'] === undefined ? undefined : json['removeFromUserId'] === null ? null : json['removeFromUserId'],
        'accessToken': json['accessToken'] === undefined ? undefined : json['accessToken'] === null ? null : json['accessToken'],
    };
}

export function DeleteUserVerificationRequestToJSON(json: any): DeleteUserVerificationRequest {
    return DeleteUserVerificationRequestToJSONTyped(json, false);
}

export function DeleteUserVerificationRequestToJSONTyped(value?: DeleteUserVerificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'removeFromUserId': value['removeFromUserId'],
        'accessToken': value['accessToken'],
    };
}

